export default __webpack_public_path__ + "04bccbc0ace497b336aaca394e3fff7d.png";